import React from 'react';
import { useDecision } from '@optimizely/react-sdk';
import { NEW_FILTERS, ROLE_MAPPING } from '@src/constants/featureFlags';
import {
	FundingLevelFilter,
	InterestsFilter,
	LearningProvidersFilter,
	ProgramTypeFilter,
	TimeToCompleteFilter,
	WeeklyEffortFilter,
} from '../Filters';
import { PathwayRolesFilter } from '../Filters/PathwayRolesFilter';
import { AcceptingApplicationsFilter } from '../Filters/AcceptingApplicationsFilter';
import { ProgramFormatFilter } from '../Filters/ProgramFormatFilter';
import styles from './FilterPane.module.scss';

export const FilterPane: React.FC = () => {
	const [rolesDecision] = useDecision(ROLE_MAPPING);
	const [filtersDecision] = useDecision(NEW_FILTERS);
	return (
		<div className={styles.filterPaneContainer}>
			{rolesDecision?.enabled ? <PathwayRolesFilter /> : null}
			{filtersDecision?.enabled ? <AcceptingApplicationsFilter /> : null}
			<FundingLevelFilter />
			<TimeToCompleteFilter />
			<WeeklyEffortFilter />
			<ProgramTypeFilter />
			{filtersDecision?.enabled ? <ProgramFormatFilter /> : null}
			<InterestsFilter />
			<LearningProvidersFilter />
		</div>
	);
};
